import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount, Ref } from 'vue'
import { getConversations } from '@/api/conversation'
import { Conversations } from '@/entities/conversation'
import ChatResponseDetails from '@/components/Chat/ChatResponseDetails.vue'
import ChatResponseConversationEvents from '@/components/Chat/ChatResponseConversationEvents.vue'
import Loading from '@/components/Loading.vue'

interface Props {
    questionId: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatResponseLogs',
  props: {
    questionId: null
  },
  setup(__props: any) {

const props = __props as {
    questionId: number
}



let questionConversations: Ref<Conversations> = ref({
    time: 0,
    answer: -1,
    deliverymethod: '',
})
const dataLoaded = ref(false)

onBeforeMount(async () => {
    dataLoaded.value = false
    // Load logs
    const { data } = await getConversations(props.questionId)
    questionConversations.value = data.data
    dataLoaded.value = true
})

return { __sfc: true,props, questionConversations, dataLoaded, ChatResponseDetails, ChatResponseConversationEvents, Loading }
}

})